/* Featured Collection Pro: Swiper coverflow, parameters matched to the
   section.store reference — rotate 24 (mobile) / 20 (1024+), depth
   380/400, stretch 0, modifier 1, no slide shadows, speed 800, loop,
   centered, 1.2 / 3 slides per view, grab cursor. Swiper loads from
   cdnjs only when a section instance is on the page. */
(function () {
  if (window.__millianFPro) return;
  window.__millianFPro = true;

  var CSS_URL = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/11.1.14/swiper-bundle.min.css';
  var JS_URL = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/11.1.14/swiper-bundle.min.js';

  function ensureSwiper(cb) {
    if (window.Swiper) return cb();
    if (!document.querySelector('link[data-mfp-swiper]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = CSS_URL;
      link.setAttribute('data-mfp-swiper', '');
      document.head.appendChild(link);
    }
    var script = document.querySelector('script[data-mfp-swiper]');
    if (!script) {
      script = document.createElement('script');
      script.src = JS_URL;
      script.defer = true;
      script.setAttribute('data-mfp-swiper', '');
      document.head.appendChild(script);
    }
    script.addEventListener('load', cb);
  }

  // Only the active card and two per side stay visible; anything further
  // out fades to nothing (slide progress tracks distance from center).
  function markFar(sw) {
    for (var i = 0; i < sw.slides.length; i++) {
      var s = sw.slides[i];
      s.classList.toggle('mfp-far', Math.abs(s.progress) > 2.05);
    }
  }

  function init(root) {
    if (root.dataset.mfpInit) return;
    root.dataset.mfpInit = '1';
    var cfg = { autoplay: false, autoplayDelay: 4000 };
    try { cfg = JSON.parse(root.querySelector('[data-mfp-config]').textContent); } catch (e) { /* defaults */ }
    new window.Swiper(root.querySelector('.mfp-swiper'), {
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      loop: true,
      speed: 800,
      spaceBetween: 0,
      slidesPerView: 1.2,
      coverflowEffect: { rotate: 24, stretch: 0, depth: 380, modifier: 1, scale: 1, slideShadows: false },
      breakpoints: {
        1024: {
          slidesPerView: 3,
          coverflowEffect: { rotate: 20, stretch: 0, depth: 400, modifier: 1, scale: 1, slideShadows: false },
        },
      },
      autoplay: cfg.autoplay
        ? { delay: cfg.autoplayDelay, pauseOnMouseEnter: true, disableOnInteraction: false }
        : false,
      navigation: {
        prevEl: root.querySelector('.mfp-prev'),
        nextEl: root.querySelector('.mfp-next'),
      },
      watchSlidesProgress: true,
      on: {
        progress: markFar,
        setTranslate: markFar,
      },
    });
  }

  function scan() {
    var roots = document.querySelectorAll('[data-millian-fpro]');
    if (!roots.length) return;
    ensureSwiper(function () { roots.forEach(init); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();
